export const commentSection = {
  details: 'details',
  adddress: 'address',
  facilities: 'facilities',
  roomlisting: 'roomlisting',
  gallery: 'gallery',
};

export const newRoomFacilities = [
  { checked: false, group: null, label: 'Air Conditioning', slug: 'unit_type_air_conditioning' },
  { checked: false, group: null, label: 'Bathroom', slug: 'unit_type_bathroom' },
  { checked: false, group: null, label: 'Chairs', slug: 'unit_type_chairs' },
  { checked: false, group: null, label: 'Closet', slug: 'unit_type_closet' },
  { checked: false, group: null, label: 'Desk', slug: 'unit_type_desk' },
  { checked: false, group: null, label: 'Door Lock', slug: 'unit_type_door_lock' },
  { checked: false, group: null, label: 'Heating', slug: 'unit_type_heating' },
  { checked: false, group: null, label: 'Kitchen', slug: 'unit_type_Kitchen' },
  { checked: false, group: null, label: 'Television', slug: 'unit_type_television' },
  { checked: false, group: null, label: 'WiFi', slug: 'unit_type_wifi' },
];

export const propertyDraftStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
};

export const propertyDraftCategory = {
  DETAIL: 'DETAIL',
  GALLERY: 'GALLERY',
};

export const other = {};
